import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { connect } from '../../../../../common/react-redux';
import * as modalActions from '../../../../../common/actions/modal';
import { set as setUI } from '../../../../../common/actions/ui';
import { BUILD_TRAY_OPEN, BUILD_TRAY_BUTTON_REF } from '@instructure/quiz-common';
import { generateImportModalId } from '../../../../../common/components/ImportModal';
import { BuildingButtons as BuildingButtonsPresenter } from './presenter';
import { getActiveQuiz } from '../../../../../common/selectors/quizzes';
import { featureOn } from '../../../../../common/util/featureCheck';
import { startQuizExportJob } from '../../../../../common/actions/quizExport';
import { addAlert, addInfo } from '../../../../../common/actions/alerts';
export function mapStateToProps(state) {
  var quiz = getActiveQuiz(state);
  return {
    activeQuizId: quiz.id,
    canExport: !state.getIn(['quizExport', "activeQuiz".concat(quiz.id)]),
    canImport: quiz.canImport(),
    hasQuestions: quiz.hasQuestions(),
    isEditing: state.get('editing') && state.get('editing').some(function (elem) {
      return elem;
    }),
    printingEnabled: featureOn('printing')
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addAlert: bindActionCreators(addAlert, dispatch),
    addInfo: bindActionCreators(addInfo, dispatch),
    openBanksTray: bindActionCreators(setUI.bind(void 0, BUILD_TRAY_OPEN, true), dispatch),
    setBanksTrayButtonRef: bindActionCreators(partial(setUI, BUILD_TRAY_BUTTON_REF), dispatch),
    startExport: bindActionCreators(startQuizExportJob, dispatch),
    openModal: bindActionCreators(modalActions.openModal.bind(modalActions, generateImportModalId('qtiImport')), dispatch)
  };
};
export var BuildingButtons = connect(mapStateToProps, mapDispatchToProps)(BuildingButtonsPresenter);
export default BuildingButtons;